// ============================================================================
// ENTITY TAX CONFIG SERVICE (ADR-0047 Phase 2 §6) — per-jurisdiction defaults,
// entity-scoped via X-Entity-ID. Today: the default tax master that pre-fills a
// new item's mapping (a pre-fill, never a runtime fallback).
// ============================================================================

import { get, put } from '../client/axiosClient';
import { entityTaxConfigEndpoints } from '../endpoints/tax.endpoints';
import type { ApiResponse, EntityTaxConfigDto, UpsertEntityTaxConfigRequest } from '../types';

class EntityTaxConfigService {
  /** Null when the entity has no jurisdiction (the API answers 404). */
  async get(): Promise<EntityTaxConfigDto | null> {
    try {
      const r = await get<ApiResponse<EntityTaxConfigDto>>(entityTaxConfigEndpoints.get());
      return r.data.data ?? null;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  }

  async upsert(data: UpsertEntityTaxConfigRequest): Promise<EntityTaxConfigDto> {
    const r = await put<ApiResponse<EntityTaxConfigDto>>(entityTaxConfigEndpoints.upsert(), data);
    return r.data.data;
  }
}

export const entityTaxConfigService = new EntityTaxConfigService();
export default entityTaxConfigService;
